.content {
  max-width: 48rem;
  flex: 1;
  overflow-y: scroll;

  & textarea {
    color: #959bab;
    font-weight: 400;
    font-size: 1.4rem;
  }

  @media screen and (min-width: $bp-small) {
    width: 47.5rem;
    max-width: 100%;
  }
}

.style-selection-wrapper {
  display: flex;
  flex-direction: column;
}

.header {
  color: var(--color-grayscale-white);
  font-weight: 400;
  font-size: 1.4rem;
  margin-bottom: 1.6rem;
}

.date-selector-wrapper {
  /* Was the shared `DashedInput` css fragment, interpolated here only. */
  display: flex;
  box-sizing: border-box;
  background-color: transparent;
  border-radius: 0.4rem;
  border: 0.1rem var(--color-texts-low-contrast) dashed;
  font-size: 1.4rem;
  height: 3.2rem;
  min-height: 3.2rem;
  font-weight: 400;
  overflow: hidden;

  &:hover {
    border: 0.1rem var(--color-texts-middle-contrast) dashed;
    background-color: var(--color-surfaces-bg-elevation-3);

    & div {
      color: var(--color-texts-low-contrast);
    }
  }

  &[data-disabled='true'] {
    background: transparent;
    border-color: var(--color-texts-low-contrast);
  }

  width: fit-content !important;

  & > div {
    padding: 0.6rem 0.8rem;
    font-size: 1.4rem;
    color: var(--color-texts-low-contrast);

    &:hover {
      background-color: var(--color-surfaces-bg-elevation-3);
    }
  }

  &[data-borderless='true'] {
    border-color: transparent;
    & > div {
      color: var(--color-texts-high-contrast);
    }
  }
}
